import { DateTime, Info } from "luxon";

const corrector = arr => arr.unshift(...arr.splice(arr.length, 1));

const WEEKDAYS_LONG = {
    ru: corrector(Info.weekdays("long", { locale: "ru" }))
};
const WEEKDAYS_SHORT = {
    ru: corrector(Info.weekdays("short", { locale: "ru" }))
};
const MONTHS = {
    ru: Info.months("long", { locale: "ru" })
};

const FIRST_DAY = {
    //en: 0,
    ru: 1
};

function formatDay(d, locale = "ru") {
    return `${WEEKDAYS_LONG[locale][d.getDay()]}, ${d.getDate()} ${
        MONTHS[locale][d.getMonth()]
        } ${d.getFullYear()}`;
}

function formatMonthTitle(d, locale = "ru") {
    return `${MONTHS[locale][d.getMonth()]} ${d.getFullYear()}`;
}

function formatWeekdayShort(i, locale) {
    return WEEKDAYS_SHORT[locale][i];
}

function formatWeekdayLong(i, locale) {
    return WEEKDAYS_SHORT[locale][i];
}

function getFirstDayOfWeek(locale) {
    return FIRST_DAY[locale];
}

export const DayPickerInputLocaleUtils = {
    formatDay,
    formatMonthTitle,
    formatWeekdayShort,
    formatWeekdayLong,
    getFirstDayOfWeek,
    LABELS: {
        ru: {
            nextMonth: "следующий месяц",
            previousMonth: "предыдущий месяц"
        }
    }
};

export function formatDate(date, format = "L", locale = "en") {
    return DateTime.fromJSDate(date)
        .setLocale(locale)
        .toFormat(Array.isArray(format) ? format[0] : format);
}

export function parseDate(str, format = "L", locale = "en") {
    const dt = DateTime.fromFormat(str, format, { locale: locale });
    return dt.isValid ? dt.toJSDate() : undefined;
}
